module.exports = __webpack_public_path__ + "static/media/2.0bf8591c.jpg";